import React, { useCallback } from 'react';
import styled from 'styled-components';
import { HomeOutlined } from '@ant-design/icons';

interface SetDefaultLandingPageProps {
  context: string;
  clickCallback: (context: string) => void;
  showIcon?: boolean;
  showText?: boolean;
  disabled?: boolean;
  className?: string,
}

const StyledSetDefaultLandingPageLink = styled.div`
`;

const SetDefaultLandingPage: React.FC<SetDefaultLandingPageProps> = ({
  clickCallback,
  context,
  showIcon = false,
  showText = true,
  className = '',
  disabled = false,
}) => {
  const clickHandler = useCallback(() => {
    if (disabled) {
      return;
    }
    clickCallback(context);
  }, [clickCallback, context, disabled]);

  return (
    <StyledSetDefaultLandingPageLink onClick={clickHandler} className={className}>
      {
        showIcon
          ? <HomeOutlined />
          : <span />
      }
      {showText && (disabled ? <i>Make default</i> : <span>Make default</span>)}
    </StyledSetDefaultLandingPageLink>
  );
};

export default SetDefaultLandingPage;
